function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: ",
        ";\n    font-family: ",
        ";\n    letter-spacing: ",
        ";\n    text-transform: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "styled-components";
import { merge } from "lodash-es";
/**
 * Simple type guard to ensure a value selected from typography (below) aligns
 * with styles for a typography element (as opposed to fontFamily or fontWeight)
 */ export function isTypographyElementStyles(value) {
    return "fontSize" in value && "fontWeight" in value && "lineHeight" in value;
}
/**
 * A styled-component mixin that sets all typography styles for a typography type
 * via styled-components flattened interpolation.
 *
 * Note: This returns an interpolated style, so you should use it directly in a
 * styled-component and not assign the return value to a specific CSS property.
 *
 * @example
 * const StyledComponent = styled.p`
 *   ${({ theme }) => theme.km.typography.body2.withAll}
 * `;
 *
 * @returns {FlattenSimpleInterpolation}
 */ function withAllStyles(param) {
    var fontSize = param.fontSize, fontWeight = param.fontWeight, lineHeight = param.lineHeight, fontFamily = param.fontFamily, letterSpacing = param.letterSpacing, textTransform = param.textTransform;
    return css(_templateObject(), fontSize, fontWeight, lineHeight, fontFamily, letterSpacing, textTransform);
}
var typographyConstants = {
    display1: {
        fontFamily: "zeitung, sans-serif",
        fontSize: "64px",
        lineHeight: "76px",
        fontWeight: "700"
    },
    display2: {
        fontFamily: "zeitung, sans-serif",
        fontSize: "56px",
        lineHeight: "64px",
        fontWeight: "700"
    },
    display3: {
        fontFamily: "zeitung, sans-serif",
        fontSize: "44px",
        lineHeight: "52px",
        fontWeight: "700"
    },
    display4: {
        fontFamily: "zeitung, sans-serif",
        fontSize: "36px",
        lineHeight: "44px",
        fontWeight: "700"
    },
    display5: {
        fontFamily: "zeitung, sans-serif",
        fontSize: "28px",
        lineHeight: "36px",
        fontWeight: "700"
    },
    display6: {
        fontFamily: "zeitung, sans-serif",
        fontSize: "24px",
        lineHeight: "32px",
        fontWeight: "700"
    },
    h1: {
        fontSize: "36px",
        lineHeight: "44px",
        fontWeight: "700"
    },
    h2: {
        fontSize: "32px",
        lineHeight: "40px",
        fontWeight: "700"
    },
    h3: {
        fontSize: "28px",
        lineHeight: "36px",
        fontWeight: "700"
    },
    h4: {
        fontSize: "24px",
        lineHeight: "32px",
        fontWeight: "700"
    },
    h5: {
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: "700"
    },
    h6: {
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: "700"
    },
    subhead: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "600"
    },
    body1: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "400"
    },
    body2: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: "400"
    },
    body3: {
        fontSize: "12px",
        lineHeight: "20px",
        fontWeight: "400"
    },
    button: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: "700"
    },
    text: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "400"
    },
    caption: {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: "500"
    },
    overline: {
        fontFamily: "Inter, monospace",
        fontSize: "10px",
        fontWeight: "600",
        letterSpacing: "1px",
        lineHeight: "16px",
        textTransform: "uppercase"
    },
    code: {
        fontFamily: '"Roboto Mono", monospace',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px"
    }
};
var typographyConstantsWithAll = merge(// Note: This was the simplest way to re-use the existing style constants
// while maintaining narrowed types: http://screen/8GoJZgx2pddMj2Z
// Other style properties are defined on typographyConstants above.
{
    display1: {
        withAll: withAllStyles(typographyConstants.display1)
    },
    display2: {
        withAll: withAllStyles(typographyConstants.display2)
    },
    display3: {
        withAll: withAllStyles(typographyConstants.display3)
    },
    display4: {
        withAll: withAllStyles(typographyConstants.display4)
    },
    display5: {
        withAll: withAllStyles(typographyConstants.display5)
    },
    display6: {
        withAll: withAllStyles(typographyConstants.display6)
    },
    h1: {
        withAll: withAllStyles(typographyConstants.h1)
    },
    h2: {
        withAll: withAllStyles(typographyConstants.h2)
    },
    h3: {
        withAll: withAllStyles(typographyConstants.h3)
    },
    h4: {
        withAll: withAllStyles(typographyConstants.h4)
    },
    h5: {
        withAll: withAllStyles(typographyConstants.h5)
    },
    h6: {
        withAll: withAllStyles(typographyConstants.h6)
    },
    subhead: {
        withAll: withAllStyles(typographyConstants.subhead)
    },
    body1: {
        withAll: withAllStyles(typographyConstants.body1)
    },
    body2: {
        withAll: withAllStyles(typographyConstants.body2)
    },
    body3: {
        withAll: withAllStyles(typographyConstants.body3)
    },
    button: {
        withAll: withAllStyles(typographyConstants.button)
    },
    text: {
        withAll: withAllStyles(typographyConstants.text)
    },
    caption: {
        withAll: withAllStyles(typographyConstants.caption)
    },
    overline: {
        withAll: withAllStyles(typographyConstants.overline)
    },
    code: {
        withAll: withAllStyles(typographyConstants.code)
    }
}, typographyConstants);
/**
 * Individual KM Typography styles.
 * Carbon: https://carbon.googleplex.com/kaggle/pages/typography
 * Figma: http://shortn/_M7DQRVIiNu
 *
 * Note: Prefer Typography.tsx components in `@kaggle/material` to these styles
 * where possible (http://shortn/_YSRymqu1oO).
 *
 * @example
 * // Don't do this:
 * const DontDoThisText = styled.div`
 *   color: ${({ theme }) => theme.km.color.text.low}
 *   font-size: ${({ theme }) => theme.km.typography.body2.fontSize};
 *   font-weight: ${({ theme }) => theme.km.typography.body2.fontWeight};
 *   line-height: ${({ theme }) => theme.km.typography.body2.lineHeight};
 *   margin-top: 16px;
 * `;
 * <DontDoThisText>I'm reinventing the wheel</DontDoThisText>
 *
 * // Prefer this:
 * import { Body2 } from '@kaggle/material';
 *
 * const DoThisText = styled(Body2)`
 *   margin-top: 16px;
 * `;
 * <DoThisText emphasis="low">I'm leveraging the component library</DoThisText>
 */ export var typography = _objectSpreadProps(_objectSpread({}, typographyConstantsWithAll), {
    /**
   * Prefer these constants when an arbitrary font-weight is needed, over
   * using a fontWeight from a specific typography style above that
   * happens to match what you need. */ fontWeight: {
        regular: "400",
        medium: "500",
        semiBold: "600",
        bold: "700"
    },
    fontFamily: {
        body: "Inter, sans-serif",
        display: "zeitung, sans-serif",
        heading: "Inter, sans-serif",
        monospace: '"Roboto Mono", monospace'
    }
});
